<template>
  <div class="modal is-active">
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-content">
      <div class="box">
        <div v-if="isErrorResponse">
          <h3 class="title is-4 has-text-danger">Submission Error</h3>
          <pre class="is-size-7">{{ formattedErrorMessage }}</pre>
        </div>
        <div v-else>
          <h3 class="title is-4 has-text-success">Submission Successful</h3>
          <pre class="is-size-7">{{ formattedSuccessMessage }}</pre>
        </div>
        <button class="button is-primary mt-3" @click="closeModal">Close</button>
      </div>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
  </div>
</template>

<script>
export default {
  name: 'ResponseModal',
  props: {
    serverResponse: {
      type: Object,
      required: true
    },
    isErrorResponse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formattedErrorMessage() {
      let message = this.serverResponse.error || 'Error';

      if (this.serverResponse.details && Array.isArray(this.serverResponse.details)) {
        this.serverResponse.details.forEach(detail => {
          message += `\nInvoice: ${detail.invoice_number}\n`;

          if (typeof detail.error === 'string') {
            // If error is a simple string, append it directly
            message += `Error: ${detail.error}\n`;
          } else if (detail.error.errors && Array.isArray(detail.error.errors)) {
            // If error is an object with an errors array, iterate over it
            detail.error.errors.forEach(err => {
              message += `Type: ${err.type}\n`;
              message += `Invoice Number: ${err.invoice_number}\n`;
              message += `Details: ${err.details}\n`;
            });
          }
        });
      }
      return message;
    },
    formattedSuccessMessage() {
      let message = this.serverResponse.status || 'Success';
      if (this.serverResponse.Invoice_Numbers) {
        message += `\nInvoice Numbers: ${this.serverResponse.Invoice_Numbers.join(', ')}`;
      }
      if (this.serverResponse.UUIDs) {
        message += `\nUUIDs: ${this.serverResponse.UUIDs.join(', ')}`;
      }
      return message;
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* Use Bulma’s modal styles or add custom styles here if needed */
</style>
